import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Dashboard</Typography>
      <div>
        <p>This is the dashboard. We'll be adding more functionality here over time, so do check back from time to time.</p>
        <p>Right now it provides shortcuts the the most frequently used sections of Studio.</p>
        <p>If you're not sure what everything is, please refer to our <a href="https://www.smartix.uk/studio/" target='_blank'>Studio documentation</a>.</p>
      </div>
    </div>
  )
}

export default HelpText